// extracted by mini-css-extract-plugin
module.exports = {"carouselSection":"CarouselSection_carouselSection__zejMz","brandCarousel":"CarouselSection_brandCarousel__3qDoS"};